import { render, staticRenderFns } from "./addDocument.vue?vue&type=template&id=319fcb08&scoped=true&lang=html&"
import script from "./addDocument.vue?vue&type=script&lang=js&"
export * from "./addDocument.vue?vue&type=script&lang=js&"
import style0 from "./addDocument.vue?vue&type=style&index=0&id=319fcb08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319fcb08",
  null
  
)

export default component.exports